export default class AppointmentSeries {
    static fromData(data) {
        if (!data) {
            return;
        }

        const appointmentSeries = new AppointmentSeries();
        appointmentSeries.id = data.id;
        appointmentSeries.start = data.start;
        appointmentSeries.end = data.end;
        appointmentSeries.interval = data.interval;
        appointmentSeries.intervalEnd = data.intervalEnd;
        appointmentSeries.weekday = data.weekday;
        appointmentSeries.isUsed = data.isUsed;
        appointmentSeries.activeBookingsUntil = data.activeBookingsUntil;

        Object.seal(appointmentSeries);
        return appointmentSeries;
    }
}
